const Colors = {
	brand400: '#F47C28',
	brand500: '#C85200',
	slate200: '#BCCACB',
	slate300: '#849697',
	slate500: '#495F61',
	teal500: '#009AA8'
};

export default Colors;